<p-dialog
  #fastProfissional
  [modal]="true"
  [visible]="true"
  [position]="'top'"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar profissional</span>
      <i class="mdi mdi-doctor ml-2 text-primary"></i>
    </div>
  </ng-template>
  <mat-tab-group>
    <mat-tab label="Dados" style="flex: 1;">
      <ng-template mat-tab-label>
        Dados
        <i
          *ngIf="formDadosValid"
          class="mdi mdi-alert-circle red"
          matTooltip="Preencha as informações corretamente"
        ></i>
      </ng-template>

      <form-info-profissional
        [parceiroType]="'profissional'"
        [entity]="entity"
        (onLoadParceiro)="setInformacoesParceiro($event)"
      ></form-info-profissional>
    </mat-tab>
    <mat-tab label="Endereços" style="flex: 1;">
      <ng-template mat-tab-label>
        Endereço
        <i
          *ngIf="formAddressValid"
          class="mdi mdi-alert-circle red"
          matTooltip="Preencha as informações corretamente"
        ></i>
      </ng-template>
      <app-fast-endereco [entity]="entity.parceiro"></app-fast-endereco>
    </mat-tab>
    <mat-tab label="Contatos">
      <app-fast-contato [entity]="entity.parceiro"></app-fast-contato>
    </mat-tab>
  </mat-tab-group>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        (click)="dialogRef.close()"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="!formValid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
